<div class="dialog-content modify-exam-diet-dialog-content">
  <!--title 標題-->
  <h1 class="dialog-title">
    {{ 'modify-exam-diet-dialog.title' | translate }}
  </h1>
  <div class="dialog-scroll-content">
    <!--檢查當日餐食-->
    <div class="input-block" [formGroup]="form">
      <label class="input-title">{{
        'modify-exam-diet-dialog.breakfast' | translate
        }}</label>
      <mat-form-field appearance="fill" [ngClass]="{ 'input-error': showFormError &&
                    (form.get('breakfast')?.invalid), }">

        <mat-select formControlName="breakfast" [placeholder]="
                    'appointment-info.select-breakfast' | translate
                  ">
          @for (breakfast of breakfasts; track breakfast.uno) {
          <mat-option [value]="breakfast.uno">{{
            breakfast.noDesc
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!-- 餐食錯誤訊息 -->
       @if (showFormError&& this.form.get('breakfast')?.invalid) {
      <mat-error class="input-error-msg">{{
        'error.breakfast-error.required' | translate
        }}</mat-error>
      }
      <!-- 午餐 -->
       @if(lunches.length > 0){
        <label class="input-title">{{
          'modify-exam-diet-dialog.lunch' | translate
          }}</label>
        <mat-form-field appearance="fill" [ngClass]="{ 'input-error': showFormError &&
                      (form.get('breakfast')?.invalid ||
                        form.get('lunch')?.invalid), }">
          <mat-select formControlName="lunch" [placeholder]="'appointment-info.select-lunch' | translate">
            @for (lunch of lunches; track lunch.uno) {
            <mat-option [value]="lunch.uno">{{
              lunch.noDesc
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <!-- 餐食錯誤訊息 -->
      @if (showFormError&& this.form.get('lunch')?.invalid) {
      <mat-error class="input-error-msg">{{
        'error.lunch-error.required' | translate
        }}</mat-error>
      }
      
    </div>


    <div class="input-warn-msg">
      <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
      <span>{{ 'modify-exam-diet-dialog.diet-hint' | translate }}</span>
    </div>

    <!--固定按鈕區塊-->
    <div class="dialog-btn-block">
      <button mat-button (click)="closeDialog()" type="button" class="btn-outline-primary btn-size-l">
        {{ 'common.button.cancel' | translate }}
      </button>
      <button mat-button (click)="onSubmit()" type="button" class="btn-fill-primary btn-size-l">
        {{ 'common.button.save-changes' | translate }}
      </button>
    </div>
  </div>
</div>